import React from 'react';

const NoctilSupportCard = ({ title, icon, listContent }) => {
  return (
    <div className="support-block-card-wrapper">
      <div className="title-wrapper">
        <h4>{title}</h4>
      </div>
      <img src={'/assets/images/' + icon} alt={'Core Features - Noctil'} />
      {listContent}
    </div>
  );
};

export default NoctilSupportCard;
